export interface Collection {
  id: string;
  title: string;
  category: string;
  cover: string;
  excerpt: string;
  date: string;
  readTime: string;
}

export const collections: Collection[] = [
  {
    id: 'col-story',
    title: '《迷人的保姆》剧情脉络深度梳理',
    category: '剧情分析',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cinematic%20desk%20scene%20with%20an%20open%20notebook%2C%20photographs%20and%20a%20cup%20of%20tea%20under%20soft%20amber%20light%2C%20deep%20navy%20shadows%2C%20editorial%20still%2C%20no%20text&width=800&height=450&seq=col-cover-story-01&orientation=landscape',
    excerpt: '从林晚初入顾家到守护住整个家，我们把每一阶段的关键转折与人物动机串联起来，帮你读懂故事里的温柔与坚持。',
    date: '2026-10-10',
    readTime: '6 分钟',
  },
  {
    id: 'col-character',
    title: '人物志：林晚的成长时间线',
    category: '角色解读',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20soft%20portrait%20of%20a%20young%20woman%20in%20warm%20window%20light%20with%20muted%20amber%20and%20navy%20tones%2C%20editorial%20still%2C%20no%20text&width=800&height=450&seq=col-cover-character-02&orientation=landscape',
    excerpt: '她从一个努力做好本职工作的保姆，成长为这个家不可或缺的一部分。四个阶段，看懂她的每一次选择。',
    date: '2026-10-08',
    readTime: '5 分钟',
  },
  {
    id: 'col-bts',
    title: '幕后花絮：剧组的一天',
    category: '幕后花絮',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20film%20set%20behind%20the%20scenes%20with%20soft%20lights%20and%20camera%20equipment%2C%20amber%20and%20navy%20tones%2C%20editorial%20still%2C%20no%20text&width=800&height=450&seq=col-cover-bts-03&orientation=landscape',
    excerpt: '从清晨的第一场戏到深夜收工，记录拍摄现场的细节与团队之间的默契配合，感受一部剧的诞生过程。',
    date: '2026-10-05',
    readTime: '4 分钟',
  },
  {
    id: 'col-music',
    title: '配乐与氛围：如何营造家的温度',
    category: '幕后花絮',
    cover:
      'https://readdy.ai/api/search-image?query=Soft%20piano%20keys%20in%20a%20warm%20dim%20room%20with%20golden%20lamp%20light%2C%20cinematic%20editorial%20still%2C%20no%20text&width=800&height=450&seq=col-cover-music-04&orientation=landscape',
    excerpt: '一段旋律如何让厨房的烟火气变得动人？本期聊聊剧中的音乐设计与声音细节。',
    date: '2026-10-02',
    readTime: '3 分钟',
  },
  {
    id: 'col-themes',
    title: '家庭剧为什么让人共鸣',
    category: '剧情分析',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20family%20living%20room%20in%20warm%20golden%20hour%20light%20with%20soft%20textures%2C%20editorial%20still%2C%20no%20text&width=800&height=450&seq=col-cover-themes-05&orientation=landscape',
    excerpt: '家庭题材的魅力，在于它讲述的其实是我们每个人身边的故事。本期从叙事结构聊起。',
    date: '2026-09-28',
    readTime: '5 分钟',
  },
  {
    id: 'col-guide',
    title: '新手观看指南：从哪一集开始',
    category: '观看指南',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20cozy%20sofa%20with%20a%20remote%20control%20and%20blanket%20in%20soft%20evening%20light%2C%20editorial%20still%2C%20no%20text&width=800&height=450&seq=col-cover-guide-06&orientation=landscape',
    excerpt: '第一次看这部剧不知道从何下手？这里给出一份循序渐进的上手路线，快速进入剧情状态。',
    date: '2026-09-24',
    readTime: '3 分钟',
  },
];